import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { devToolsSliceActions, devToolsSliceSelector } from '@features/devTools'

export function useUnreleasedHostingVersionsState() {
  const dispatch = useDispatch()

  const enabled = useSelector(
    (state: RootState) => devToolsSliceSelector(state).displayUnreleasedHostingVersions
  )

  const set = (val: boolean) =>
    dispatch(devToolsSliceActions.setDisplayUnreleasedHostingVersions(val))

  return { displayUnreleasedHostingVersions: enabled, setDisplayUnreleasedHostingVersions: set }
}
